import axios from 'axios';

export const sportsRequest = () => axios.get(`/v1/sports`);
